import VillaList from './VillaList';

export default VillaList;
